module.exports = __webpack_public_path__ + "static/media/hifi-05d.119f8b69.png";